export default {
	methods: 
    {		
		async nuevoModal()
		{
			await this.changeGlobal({state: 'indexData', boolean: false});
			await this.updateGlobal({state: 'openModal/modal/value',    data: true });
			await this.updateGlobal({state: 'openModal/modal/title',    data: 'Nuevo Usuario del sistema'});
			await this.updateGlobal({state: 'openModal/modal/modal',    data: 'Nuevo'});
		},		
	},
}